import TradingRates from "./TradingRates";
export default TradingRates;
